/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetTuitionRateTierResponse } from './GetTuitionRateTierResponse';
import {
    GetTuitionRateTierResponseFromJSON,
    GetTuitionRateTierResponseFromJSONTyped,
    GetTuitionRateTierResponseToJSON,
    GetTuitionRateTierResponseToJSONTyped,
} from './GetTuitionRateTierResponse';
import type { TuitionRateType } from './TuitionRateType';
import {
    TuitionRateTypeFromJSON,
    TuitionRateTypeFromJSONTyped,
    TuitionRateTypeToJSON,
    TuitionRateTypeToJSONTyped,
} from './TuitionRateType';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetTuitionRatePlanResponse
 */
export interface GetTuitionRatePlanResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetTuitionRatePlanResponse
     */
    id: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetTuitionRatePlanResponse
     */
    name: string;
    /**
     * 
     * @type {TuitionRateType}
     * @memberof GetTuitionRatePlanResponse
     */
    rateType: TuitionRateType;
    /**
     * 
     * @type {boolean}
     * @memberof GetTuitionRatePlanResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {Array<GetTuitionRateTierResponse>}
     * @memberof GetTuitionRatePlanResponse
     */
    tiers: Array<GetTuitionRateTierResponse>;
}



/**
 * Check if a given object implements the GetTuitionRatePlanResponse interface.
 */
export function instanceOfGetTuitionRatePlanResponse(value: object): value is GetTuitionRatePlanResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('rateType' in value) || value['rateType'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('tiers' in value) || value['tiers'] === undefined) return false;
    return true;
}

export function GetTuitionRatePlanResponseFromJSON(json: any): GetTuitionRatePlanResponse {
    return GetTuitionRatePlanResponseFromJSONTyped(json, false);
}

export function GetTuitionRatePlanResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTuitionRatePlanResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ApiUserTasksGetPageParameterFromJSON(json['id']),
        'name': json['name'],
        'rateType': TuitionRateTypeFromJSON(json['rateType']),
        'isActive': json['isActive'],
        'tiers': ((json['tiers'] as Array<any>).map(GetTuitionRateTierResponseFromJSON)),
    };
}

export function GetTuitionRatePlanResponseToJSON(json: any): GetTuitionRatePlanResponse {
    return GetTuitionRatePlanResponseToJSONTyped(json, false);
}

export function GetTuitionRatePlanResponseToJSONTyped(value?: GetTuitionRatePlanResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ApiUserTasksGetPageParameterToJSON(value['id']),
        'name': value['name'],
        'rateType': TuitionRateTypeToJSON(value['rateType']),
        'isActive': value['isActive'],
        'tiers': ((value['tiers'] as Array<any>).map(GetTuitionRateTierResponseToJSON)),
    };
}

